import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { SessionService } from '@connect-services/src/sdk/api';

export const SESSION_STORE_KEY = 'session';

export async function SessionResolver(): Promise<void> {
    const services = {
        sessionService: inject(SessionService),
    };

    await startSession(services);
}

async function startSession(services: { sessionService: SessionService }): Promise<void> {
    const sessionId = sessionStorage.getItem(SESSION_STORE_KEY);

    if (sessionId) {
        return;
    }

    const session = await firstValueFrom(services.sessionService.sessionControllerPost());

    sessionStorage.setItem(SESSION_STORE_KEY, session.id);
}
